export const COLLECTIONS = {
    REQUESTS: "requests",
    USERS: "users",
    RECIPES: "recipes",
    PAGES: "pages",
}